export function relativeTime(dateStr: string): string {
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days === 1) return "yesterday";
  if (days < 7) return `${days}d ago`;
  return new Date(dateStr).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
}

export function formatMessageTime(dateStr: string): string {
  return new Date(dateStr).toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

/**
 * Prefix a noun with the correct indefinite article: "a Plumber" but
 * "an Electrician". Plural phrases take no article at all ("Solar
 * Panels", "Bi-Fold or Sliding Doors"; trailing parentheticals are
 * ignored). Vowel-letter check is sufficient for the trade names and
 * project titles in our data (no hour/university-style exceptions).
 */
export function withArticle(noun: string): string {
  const lastWord =
    noun.replace(/\s*\([^)]*\)\s*$/, "").trim().split(/\s+/).pop() ?? "";
  if (/s$/i.test(lastWord) && !/ss$/i.test(lastWord)) return noun;
  return /^[aeiou]/i.test(noun) ? `an ${noun}` : `a ${noun}`;
}
